<template>
  <div v-if="isLoaded" class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/photo-reports">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Редактирование фотоотчёта</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Название фотоотчёта" name="title"></new-input>
                  <edit-drop-down field-name="title" title="Альбом" :id="parentId.albums" :url="apiUrls.content"
                                  name="album_id"></edit-drop-down>
                  <edit-drop-down field-name="title" title="Автор" :id="parentId.authors" :url="apiUrls.content"
                                  name="author_id"></edit-drop-down>
                  <calendar name="created_at" title="Дата создания"></calendar>
                  <new-input title="Alt" name="seo_alt"></new-input>
                  <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                             name="img"></edit-file>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author" title="Отображать автора"></checkbox>
                      <checkbox name="show_date" title="Отображать дату"></checkbox>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Название страницы" name="seo_title"></new-input>
                  <new-text-area title="Описание" name="seo_desc"></new-text-area>
                  <new-text-area title="Ключевые слова" name="seo_key"></new-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import Checkbox from '@/components/edit-form/Checkbox'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import Calendar from '../../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        ckeditor: null,
        isLoaded: false,
        text: ''
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
        'updateNews'
      ]),
      ...mapMutations([
        'setItemField',
        'resetModule',
        'setFileExtensions'
      ]),
      onSubmit () {
        let object = {
          album_id: this.item.album_id
        }
        this.edit({
          title: this.item.title,
          img: this.item.img,
          created_at: this.item.created_at,
          author_id: this.item.author_id,
          object: JSON.stringify(object),
          show_author: this.item.show_author,
          show_date: this.item.show_date,
          seo_title: this.item.seo_title,
          seo_desc: this.item.seo_desc,
          seo_key: this.item.seo_key,
          seo_alt: this.item.seo_alt,
        })
          .then(data => {
            this.updateNews({
              title: data.article.title,
              id: data.article.id,
              newsId: data.lastNews.id,
              section_id: this.parentId.photoReports,
              is_active: this.item.is_active,
              url: {
                categoryId: null,
                articleUrl: data.article.url
              },
              img: data.article.img,
              subtext: data.article.seo_desc
            })
          })
      }
    },
    created () {
      this.resetModule()
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Фотоотчёты',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование фотоотчёта',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите название фотоотчёта', hasError: false},
          created_at: {message: 'Введите дату создания', hasError: false, isNullable: true},
          author_id: {message: 'Выберите автора фотоотчёта', hasError: false, isNullable: true},
          show_author: {isNullable: true, hasError: false},
          show_date: {isNullable: true, hasError: false},
          seo_alt: {isNullable: true, hasError: false},
          album_id: {message: 'Выберите альбом фотоотчёта', hasError: false},
          seo_title: {message: 'Введите название страницы', hasError: false},
          seo_desc: {message: 'Напишите краткое описание', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false},
          seo_key: {message: 'Напишите ключевые слова', hasError: false, isNullable: true},
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then(response => {
        for (let key in response.object) {
          if (response.object.hasOwnProperty(key)) {
            this.setItemField({fieldName: key, value: response.object[key]})
          }
        }
        this.isLoaded = true
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      Checkbox
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/seminars/photo-reports/pages/Edit.vue